import Vue from "vue";

// v-dialogDrag: 弹窗拖拽属性
Vue.directive("dialogDrag", {
  bind(el, binding, vnode, oldVnode) {
    // 弹窗可移动
    // const el = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector(".canmove");
    if (dragDom != undefined) {
      //主页内table弹窗可移动
      // console.log(el);
      // console.log(dragDom);

      //el.style.cursor = 'move';
      // el.style.cssText += ';cursor:move;'
      dragDom.style.cssText += ";cursor:move;";
      //el.style.cssText += ';top:0px;'

      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = (function() {
        if (window.document.currentStyle) {
          return (dom, attr) => dom.currentStyle[attr];
        } else {
          return (dom, attr) => getComputedStyle(dom, false)[attr];
        }
      })();
      const hasClass = (elem, cls) => {
        cls = cls || "";
        if (cls.replace(/\s/g, "").length == 0) return false;
        return new RegExp(" " + cls + " ").test(" " + elem.className + " ");
      };
      // 拖动方法
      const dragFn = (e) => {
        //获取顶部banner的高度和侧边栏的宽度，因为弹窗背景变透明了，为保障视觉效果，所以进一步缩小可移动区域，使其不显示在banner和侧边栏位置。
        //先判断引用此js的页面是否含有顶部栏和侧边栏元素。
        let bannerHeight;
        let leftBarWidth;
        if (document.getElementById("el-header")) {
          bannerHeight = document.getElementById("el-header").offsetHeight;
        }
        if (document.getElementById("el-aside")) {
          leftBarWidth = document.getElementById("el-aside").offsetWidth;
        }
        bannerHeight ??= 0;
        leftBarWidth ??= 0;
        // console.log('111'+bannerHeight);
        // console.log('222'+leftBarWidth);

        //获取可移动区域内鼠标点击点相对于浏览器屏幕页面左上顶角的横纵坐标。
        const clientX = e.clientX;
        const clientY = e.clientY;

        //获取可移动区域的左上顶角相对于浏览器屏幕页面左上顶角的横纵坐标。
        const offsetLeft = el.offsetLeft;
        const offsetTop = el.offsetTop;

        //根据相对差计算出可移动区域内鼠标点击点相对于可移动区域的左上顶角的横纵坐标。
        const calX = e.clientX - el.offsetLeft;
        const calY = e.clientY - el.offsetTop;

        //获取可移动区域的整体宽度和高度
        const dragDomWidth = el.offsetWidth;
        const dragDomheight = el.offsetHeight;

        //获取浏览器屏幕页面里body宽度和高度。
        const screenWidth = document.body.clientWidth; // body当前宽度
        const screenHeight = document.documentElement.clientHeight; // html可见区域高度(应为body高度，可某些环境下无法获取)

        //计算出在保障可移动区域整体可见的前提下，可移动区域左上顶角的向左和向右移动的极限偏移量。
        // const minDragDomLeft = offsetLeft;
        //    const maxDragDomLeft = screenWidth - offsetLeft - dragDomWidth;
        const minDragDomLeft = leftBarWidth;
        const maxDragDomLeft = screenWidth - dragDomWidth;
        //计算出在保障可移动区域整体可见的前提下，可移动区域左上顶角的向上和向下移动的极限偏移量。
        // const minDragDomTop = offsetTop;
        // const maxDragDomTop = screenHeight - offsetTop - dragDomheight;
        const minDragDomTop = bannerHeight;
        const maxDragDomTop = screenHeight - dragDomheight;

        //先去掉margin的影响。
        //el.style.cssText+=`margin:0;`;

        // 获取到可移动区域当前的定位属性left和top的值，带px则正则匹配替换。

        // let styL = sty(el, 'left');
        // let styT = sty(el, 'top');

        // // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        // if (styL.includes('%')) {
        // 	styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
        // 	styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
        // } else {
        // 	styL = +styL.replace(/\px/g, '');
        // 	styT = +styT.replace(/\px/g, '');
        // };

        // console.log('clientX:'+clientX);
        // console.log('clientY:'+clientY);
        // console.log('offsetLeft:'+offsetLeft);
        // console.log('offsetTop:'+offsetTop);
        // console.log('calX:'+calX);
        // console.log('calY:'+calY);
        // console.log('dragDomWidth:'+dragDomWidth);
        // console.log('dragDomheight:'+dragDomheight);
        // console.log('screenWidth:'+screenWidth);
        // console.log('screenHeight:'+screenHeight);
        // console.log('minDragDomLeft:'+minDragDomLeft);
        // console.log('maxDragDomLeft:'+maxDragDomLeft);
        // console.log('minDragDomTop:'+minDragDomTop);
        // console.log('maxDragDomTop:'+maxDragDomTop);
        // console.log('styL:'+styL);
        // console.log('styT:'+styT);

        document.onmousemove = function(e) {
          // 通过事件委托，计算移动的距离
          //注意这里的e.clientX和e.clientY是指实时移动时鼠标光标点相对于浏览器屏幕页面左上顶角的横纵坐标。
          //计算出鼠标移动时可移动区域左上顶角的横纵坐标偏移量。
          let left = e.clientX - calX;
          let top = e.clientY - calY;
          // console.log(left);
          // console.log(top);

          // // 左右边界处理
          if (left > minDragDomLeft) {
            if (left > maxDragDomLeft) {
              left = maxDragDomLeft;
            }
          } else {
            left = minDragDomLeft;
          }

          // // 上下边界处理
          if (top > minDragDomTop) {
            if (top > maxDragDomTop) {
              top = maxDragDomTop;
            }
          } else {
            top = minDragDomTop;
          }

          // 移动当前元素
          //为避免外边距导致定位偏差，所以这里也取消掉margin值。
          el.style.cssText += `;left:${left}px;top:${top}px;margin:0;
				-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;
				-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;`;
          //console.log(el.style.cssText);
        };

        document.onmouseup = function(e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
      //注意弹窗拖动时应该是按住标题才可以拖动，而不应该在弹窗整体区域内按下鼠标就都可以拖动，因为这个插件是要用在很多弹窗的，而有的弹窗里有滑块功能，应该使滑块滑动时弹窗不要跟着滑动。
      dragDom.onmousedown = (e) => {
        // console.log(dragDom.getAttribute("modal-title"));
        // 鼠标在可移动区域内按下时触发
        if (hasClass(dragDom, "modal-title canmove")) {
          if (!hasClass(dragDom.querySelector("div .la-thumbtack"), "fixed"))
            dragFn(e);
        } else {
          dragFn(e);
        }
      };
    }
  },
});
